import React, { FC } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Typography, Link } from '@dxb-web-ui-framework/design-system';
import { Nullable } from '@dxb-web-ui-framework/common/types';
import { getRoutePath } from '../../Routes/routePaths';

interface HeaderLogoProps {
  logo: string;
  isMobile: boolean;
  alternateText: string;
  customerId: Nullable<string>;
}

const HeaderLogo: FC<HeaderLogoProps> = ({ logo, isMobile, alternateText, customerId }): JSX.Element => (
  <Typography variant={'h5'} component={'h1'}>
    <Link
      component={RouterLink}
      to={customerId ? getRoutePath({ routeKey: 'dashboard', customerId }) : '/'}
      title={alternateText}
      style={{ display: 'block' }}>
      <img src={logo} width={isMobile ? 38 : 125} height={isMobile ? 32 : 36} alt={alternateText} aria-hidden={true} />
      <Typography variant={'srOnly'}>{alternateText}</Typography>
    </Link>
  </Typography>
);

export { HeaderLogo };
